export default "__VITE_ASSET__DAjcPG15__"